import { combineReducers } from '@reduxjs/toolkit';
import archiveFilterModal from 'shared/store/features/archiveFilterModalSlice';
import workOrders from 'shared/store/features/workOrdersSlice';
import editWorkOrderModal from 'shared/store/features/editWorkOrderModalSlice';
import workOrdersTable from 'shared/store/features/workOrdersTableSlice';
import alert from 'shared/store/features/alertSlice';
import archiveWorkOrdersModal from 'shared/store/features/archiveWorkOrdersModalSlice';
import archiveFilterStatus from 'shared/store/features/archiveFilterStatusSlice';
import isUserLoggedIn from 'shared/store/features/isUserLoggedInSlice';
import tableLoader from 'shared/store/features/tableLoaderSlice';

const rootReducer = combineReducers({
  archiveFilterModal,
  workOrders,
  editWorkOrderModal,
  archiveWorkOrdersModal,
  workOrdersTable,
  alert,
  archiveFilterStatus,
  isUserLoggedIn,
  tableLoader
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
